module.exports = __webpack_public_path__ + "static/media/toxic-tank.33b06f94.svg";